export const join = (...items: string[]): string =>
	items.map((item) => item.replace(/^\/+/, '').replace(/\/+$/, '')).join('/');
